import React from "react";
import { useGetEmployeePhoto } from "../hooks/useGetEmployeePhoto";
import { Avatar, Skeleton } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

export enum AvatarSize {
  small = "h-6 w-6 text-xs",
  medium = "h-10 w-10",
  large = "h-12 w-12 text-2xxl",
  xl = "h-[60px] w-[60px]",
}

const CxEmployeeAvatar = ({
  entraId,
  photoSize = AvatarSize.small,
  displayName,
  sx,
}: {
  entraId: string;
  photoSize?: AvatarSize;
  displayName?: string;
  sx?: SxProps<Theme>;
}) => {
  const { data, isLoading } = useGetEmployeePhoto(entraId);

  if (entraId && isLoading) {
    return <Skeleton variant="circular" className={photoSize} />;
  } else if (data && data !== "") {
    return (
      <Avatar
        component={"span"}
        className={photoSize}
        alt={displayName}
        src={data}
        sx={sx}
      />
    );
  }
  const nameSplit = displayName?.split(" ");
  const firstName = nameSplit?.[0]?.[0]?.toUpperCase();
  const lastName = nameSplit?.[1]?.[0]?.toUpperCase();
  if (firstName || lastName) {
    return (
      <Avatar component={"span"} alt={displayName} className={photoSize} sx={sx}>
        {firstName ?? ""}
        {lastName ?? ""}
      </Avatar>
    );
  }
  return null;
};

export default CxEmployeeAvatar;
